/* agbis.js - Notify me on an out-of-stock configuration (marker `agbis`, SRM SPEC 147).
   Source: theme-test/back-in-stock/src/assets/agbis.js; build_section.py writes assets/agbis.js
   from it with the Phosphor icons in place of the ICONS mark. Never hand-edit the staged copy.

   A port of the approved prototype pages/back-in-stock/scripts/agbis-r5.js (A's picks: button V1
   at R3, window 1 "grows from the button" at R4, R5 / R5b / R5c). Kept BYTE FOR BYTE (qa_port
   PORT-6 compares them): the motion (track, stopAll, ghost, plateLabel, onX, onY, morphIn,
   morphOut, fadeForm, settlePhoto), the window's panels (settle, setPanel, showDone, trapFocus,
   focusables), Need it sooner's rows (varying, soonerRow, fillSooner), fillItem, Show me (showMe,
   glide, optControl, traceSelect, selTraces). What the port changed:
   - the page is the live theme: its own variant selector (assets/dawn-variant-selector.js) owns
     the options, the ADD TO CART and the two containers. This file follows it: a change on any
     option (window, capture phase) and the theme's own availability write (a MutationObserver on
     #out-of-stock-container's style) re-read the configuration; the state words land on
     html[data-agbis-state], which also swaps the Quick Ship panel's date (snippets/agbis-qs.liquid)
   - the data is the page's own (#agbis-data, snippets/agbis-notify.liquid): the variants, a staff
     restock date per variant (custom.restock_date, used when later than today), and the in-stock
     Quick Ship products of the same type; "Need it sooner?" is tools/catalog.py sooner() written
     here (PORT-7 holds them equal on the same catalog)
   - every listener sits on window in the capture phase (the theme's document-level stoppers)
   - the submit: "mock" (the preview, nothing leaves the page) or "live" (POST to the SRM restock
     door), by the theme setting agbis_mode; a filled honeypot answers like a success, sends nothing
   - Show me selects through the theme's own window.variantSelector.selectVariantById
   - the chair card (agcp) on an out-of-stock desk (R5b): the page has no ADD TO CART for the tick
     to ride on, so the tick adds the chair alone and opens the cart drawer; a quantity press does
     not tick it
   - not ported (prototype only): the bar, windows 2 and 3, the capture's steppers and form guard
   R6b (A, 2026-10-02: "the notify me when back in stock needs to be a lot more smoother"; the press
   took 61 ms and its first frame 85 ms on the v3.2 preview at CPU x1, the local prototype 15 / 21):
   - warm on intent: a pointer over, a press going down, a touch or the focus on the plate shows the
     window at 0.1 % (aria-hidden, inert), laid out and rastered, so the press only reads and starts
     the motion; a warm that never opens cools after 3 s
   - the press reads first (the plate, the window, the plate's ink, the scrollbar) and writes after
   - the scroll lock stays R5's (overflow + the scrollbar's width as padding on html); the window
     spans 100vw (agbis-port.css), so the lock never moves it from where the warm read it; never
     scrollbar-gutter: on the root it narrows every vw unit by the scrollbar, and the theme sizes
     its menu in vw under transition: all (246 font-size transitions on the main thread, measured)
   - the window's will-change is permanent (agbis-port.css); the landing toggle is gone
   - the window lives beside <body> (the theme's body:has() rules restyled ~570 elements for every
     node the press added); it copies <body>'s inherited look once (inheritBody)
   R6c (the live path can never drop a subscription):
   - valid() is the SRM door's own rule (supplier-srm app/routes/restock.py EMAIL_RE, by text, and its
     254 cap; qa_port PORT-18), so the field refuses what the door would; the door's 400 is a fallback
   - the honeypot carries no word an autofill heuristic reads (name agbis_x, no id, label or
     placeholder; autocomplete off; inert, so no browser can focus or fill it; off-screen; out of the tab
     order; qa_port PORT-17); a filled one still shows the success and sends nothing, and post() sends the
     field's own value as hp so the door's check (restock.py) does the bot work behind it
   morphIn, stopAll and valid differ from agbis-r5.js by exactly these (qa_port PORT-6 lists them) */
(function () {
  'use strict';
  if (window.AGBIS_BOUND) return;
  var DATA = document.getElementById('agbis-data');
  if (!DATA) return;
  var D;
  try { D = JSON.parse(DATA.textContent); } catch (e) { return; }
  if (!D || !D.product || !D.product.variants || !D.product.variants.length) return;
  window.AGBIS_BOUND = true;
  var P = D.product;
  var DAYS = D.days || 18;
  var SOONER = {};
  var MONTHS = ['Jan.', 'Feb.', 'March', 'April', 'May', 'June', 'July', 'Aug.', 'Sept.', 'Oct.', 'Nov.', 'Dec.'];
  var html = document.documentElement;
  var OPT = P.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
  var ICON = {"bell": "<svg aria-hidden=\"true\" focusable=\"false\" width=\"16\" height=\"16\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" fill=\"currentColor\"><path d=\"M221.8,175.94C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.81a40,40,0,0,0,78.38,0H208a16,16,0,0,0,13.8-24.06ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216ZM48,184c7.7-13.24,16-43.92,16-80a64,64,0,1,1,128,0c0,36.05,8.28,66.73,16,80Z\"/></svg>", "x": "<svg aria-hidden=\"true\" focusable=\"false\" width=\"20\" height=\"20\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" fill=\"currentColor\"><path d=\"M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z\"/></svg>", "check": "<svg aria-hidden=\"true\" focusable=\"false\" width=\"28\" height=\"28\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" fill=\"currentColor\"><path d=\"M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z\"/></svg>", "cal": "<svg aria-hidden=\"true\" focusable=\"false\" width=\"18\" height=\"18\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 256 256\" fill=\"currentColor\"><path d=\"M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-38.34-85.66a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L116,164.69l42.34-42.35A8,8,0,0,1,169.66,122.34Z\"/></svg>"};
  /* the spec list's labels: the store's option names, said the way a shopper says them */
  var LABEL = { 'Primary Finishing': 'Finish', 'Finishing': 'Finish', 'Finishing Color': 'Finish', 'Return Desk': 'Return', 'Size': 'Size' };
  var subscribed = {};
  var lastTrigger = null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  /* plain numerals, no decimals when .00 (the brand's price rule; tools/catalog.py money) */
  function money(c) {
    c = Math.round(c); var d = Math.floor(c / 100), r = c % 100;
    return '$' + d.toLocaleString('en-US') + (r ? '.' + (r < 10 ? '0' : '') + r : '');
  }
  function srcOf(x) { return typeof x === 'string' ? x : (x && x.src) || ''; }
  /* the theme's image_url carries its own width: replaced, never doubled */
  function img(src, w) {
    src = srcOf(src); if (!src) return '';
    src = src.indexOf('//') === 0 ? 'https:' + src : src;
    src = src.replace(/([?&])width=\d+(&|$)/, '$1').replace(/[?&]$/, '');
    return src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function setAttr(n, k, v) { if (n.getAttribute(k) !== v) n.setAttribute(k, v); }

  /* ---------- the restock date ----------
     today + 2.5 weeks (A, 2026-09-30, rounded up to whole days), AP style; a staff date on the
     variant (custom.restock_date) replaces it while it is later than today */
  function staffDate(v) {
    var m = v && v.restock && /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v.restock));
    if (!m) return null;
    var d = new Date(+m[1], +m[2] - 1, +m[3]), t = new Date();
    t.setHours(23, 59, 59, 0);
    return d > t ? d : null;
  }
  function backBy(v) {
    v = v || window.AGBIS_VARIANT;
    var d = staffDate(v);
    if (!d) { d = new Date(); d.setDate(d.getDate() + DAYS); }
    return MONTHS[d.getMonth()] + ' ' + d.getDate();
  }
  function eta(v) { return 'Estimated to be back by ' + backBy(v); }   /* A, 2026-10-01 */

  /* ---------- the configuration: read from the theme's own controls ---------- */
  function radioFor(name) { return qa('input[type=radio][name="' + name + '"]'); }
  function idInput() { return document.getElementById('product-variant-id'); }
  function byId(id) { return P.variants.filter(function (x) { return String(x.id) === String(id); })[0] || null; }
  function current() {
    var i0 = idInput(), base = byId(i0 && i0.value) || P.variants[0];
    return OPT.map(function (name, i) {
      var r = radioFor(name).filter(function (x) { return x.checked; })[0];
      if (r) return r.value;
      var s = q('select[name="' + name + '"]');
      return s ? s.value : base.options[i];
    });
  }
  function find(opts) {
    return P.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0] || null;
  }
  function isOut() { return html.getAttribute('data-agbis-state') === 'out'; }

  /* ---------- the buy column ----------
     The theme's own updateAvailability() shows and hides the two containers 50-300 ms after a
     change; they are written here too, in the frame of the press (Show me), and only when they
     differ, so the theme's later write is a no-op and nothing restyles for nothing. */
  function render() {
    var i0 = idInput();
    var v = find(current()) || byId(i0 && i0.value);
    if (!v) return;
    var out = !v.available;
    var atc = document.getElementById('add-to-cart-container'), oos = document.getElementById('out-of-stock-container');
    if (atc && atc.style.display !== (out ? 'none' : '')) atc.style.display = out ? 'none' : '';
    if (oos && oos.style.display !== (out ? '' : 'none')) oos.style.display = out ? '' : 'none';
    var word = backBy(v);
    qa('[data-agbis-date]').forEach(function (n) { if (n.textContent !== word) n.textContent = word; });
    chair(out);
    setAttr(html, 'data-agbis-state', out ? 'out' : 'available');
    window.AGBIS_VARIANT = v;
    if (out && dialog) fillItem();   /* preload the thumbnail before the press, never an empty box */
  }

  /* ---------- the chair card (agcp) on an out-of-stock desk (R5b) ----------
     A: the card is the same in both states. In stock its tick rides the page's ADD TO CART (agcp.js);
     out of stock there is none, so the tick adds the chair on its own and the cart drawer opens, the
     theme's own post-add sequence (refreshCart, then open). A stock flip clears the tick. */
  var CHAIR_OUT = null;
  function chairCheck() { return q('[data-agcp-card] [data-agcp-check]'); }
  function chair(out) {
    var cb = chairCheck();
    if (cb && CHAIR_OUT !== null && CHAIR_OUT !== out && cb.checked) {
      cb.checked = false;
      cb.dispatchEvent(new Event('change', { bubbles: true }));   /* agcp.js repaints the page button */
    }
    CHAIR_OUT = out;
  }
  function flash(node, word) {
    if (!node || node.getAttribute('data-agbis-flash')) return;
    var was = node.textContent; node.setAttribute('data-agbis-flash', '1'); node.textContent = word;
    setTimeout(function () { node.textContent = was; node.removeAttribute('data-agbis-flash'); }, 2000);
  }
  function chairAdd(cb) {
    var c = cb.closest('[data-agcp-card]');
    var id = parseInt(c && c.getAttribute('data-variant-id'), 10);
    if (!id) return;
    var qn = q('[data-agcp-qty]', c), n = Math.max(1, parseInt(qn && qn.value, 10) || 1);
    var price = q('[data-agcp-price]', c);
    cb.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: n }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add ' + r.status);
      return r.json();
    }).then(function () {
      window.AGBIS_CHAIR_ADD = { variant_id: id, quantity: n };
      flash(price, 'Added');
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.open === 'function') {
        return Promise.resolve(typeof d.refreshCart === 'function' ? d.refreshCart() : null).then(function () { d.open(); });
      }
    }).catch(function () {
      flash(price, 'Out of stock');
    }).then(function () { cb.checked = false; cb.disabled = false; });
  }

  /* ---------- email 2's ADD TO CART (R5: the variant page with agbis=add) ----------
     The configuration is back: it is added once and the cart drawer opens, the theme's own post-add
     sequence. The word leaves the address at once, so a reload or a shared link never adds again;
     a session key per variant covers back and forward. Out of stock again by then = the page as it is. */
  function addFromLink() {
    if (!/[?&]agbis=add(&|$)/.test(location.search)) return;
    try {
      var u = new URL(location.href);
      u.searchParams.delete('agbis');
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
    } catch (e) { /* the add still runs once by the session key */ }
    var v = window.AGBIS_VARIANT;
    if (!v || !v.available) return;
    var key = 'agbis-add-' + v.id, seen = false;
    try { seen = sessionStorage.getItem(key) === '1'; sessionStorage.setItem(key, '1'); } catch (e) { /* private mode: once per load */ }
    if (seen) return;
    var ready = window.customElements && customElements.whenDefined
      ? Promise.race([customElements.whenDefined('cart-drawer'), new Promise(function (r) { setTimeout(r, 3000); })])
      : Promise.resolve();
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add ' + r.status);
      return r.json();
    }).then(function () {
      window.AGBIS_LINK_ADD = { variant_id: v.id, quantity: 1 };
      return ready.then(function () {
        var d = document.querySelector('cart-drawer');
        if (d && typeof d.open === 'function') {
          return Promise.resolve(typeof d.refreshCart === 'function' ? d.refreshCart() : null).then(function () { d.open(); });
        }
      });
    }).catch(function () { /* the page's own ADD TO CART is right there */ });
  }

  /* ---------- Need it sooner? (tools/catalog.py sooner, PORT-7) ----------
     ONE list: this desk's in-stock configurations, closest first; then other Quick Ship desks of the
     same type, the same size first, then the nearest size; one row per other desk; three rows. */
  var SIZE_RE = /^\s*(\d+)\s*[′']\s*(?:(\d+)\s*[″"])?/;
  function role(name) {
    var n = String(name).toLowerCase();
    return n.indexOf('finish') >= 0 ? 'finishing' : n.indexOf('return') >= 0 ? 'return' : n.indexOf('size') >= 0 ? 'size' : n;
  }
  function optOf(names, opts, r) {
    for (var i = 0; i < names.length; i++) if (role(names[i]) === r) return opts[i] || '';
    return '';
  }
  function inches(size) { var m = SIZE_RE.exec(size || ''); return m ? parseInt(m[1], 10) * 12 + parseInt(m[2] || '0', 10) : null; }
  function view(p, names, x, ref) {
    var v = {
      id: x.id, handle: p.handle, title: p.title, short: String(p.title).split('·')[0].trim(),
      finishing: optOf(names, x.options, 'finishing'), 'return': optOf(names, x.options, 'return'),
      size: optOf(names, x.options, 'size'), sku: x.sku || '', price: x.price, price_label: money(x.price),
      image: x.featured_image || p.featured_image || '', path: '/products/' + p.handle + '?variant=' + x.id,
      same: !!ref && ref.handle === p.handle
    };
    if (ref) v.differs = ['finishing', 'return', 'size'].filter(function (k) { return v[k] && v[k] !== ref[k]; })
      .map(function (k) { return v[k]; }).join(' · ');
    return v;
  }
  function cmp(a, b) {
    for (var i = 0; i < a.length; i++) { if (a[i] < b[i]) return -1; if (a[i] > b[i]) return 1; }
    return 0;
  }
  function sooner(v, k) {
    k = k || 3;
    var me = view(P, OPT, v);
    var common = function (x) { return x.options.filter(function (o, i) { return o === v.options[i]; }).length; };
    var same = P.variants.filter(function (x) { return x.available && x.id !== v.id; })
      .map(function (x, i) { return { x: x, key: [-common(x), Math.abs(x.price - v.price), i] }; })
      .sort(function (a, b) { return cmp(a.key, b.key); }).map(function (s) { return s.x; });
    var size = inches(me.size), others = [];
    (D.pool || []).forEach(function (p, pi) {
      if (p.handle === P.handle || p.type !== P.type) return;
      var names = p.options.map(function (o) { return typeof o === 'string' ? o : o.name; });
      var cands = p.variants.filter(function (x) { return x.available; });
      if (!cands.length) return;
      var rank = function (x) {
        var s = inches(optOf(names, x.options, 'size'));
        var gap = s !== null && size !== null ? Math.abs(s - size) : 1e6;
        return [gap, optOf(names, x.options, 'return') !== me['return'] ? 1 : 0,
                optOf(names, x.options, 'finishing') !== me.finishing ? 1 : 0, Math.abs(x.price - v.price)];
      };
      var best = cands[0], br = rank(best);
      cands.forEach(function (x) { var r = rank(x); if (cmp(r, br) < 0) { best = x; br = r; } });
      others.push({ r: br.concat([pi]), p: p, names: names, x: best });
    });
    others.sort(function (a, b) { return cmp(a.r, b.r); });
    var out = same.map(function (x) { var s = view(P, OPT, x, me); s.group = 'variant'; return s; });
    others.forEach(function (o) { var s = view(o.p, o.names, o.x, me); s.group = o.r[0] === 0 ? 'same-size' : 'other-size'; out.push(s); });
    return out.slice(0, k);
  }

  /* ---------- the window ---------- */
  var overlay, ghosts, scrim, dialog, stage, form, done, input, err, banner, submit, settleTimer, closing = false;
  var warmed = false, coolTimer = 0;   /* R6b: the window shown unseen ahead of the press */

  function varying(opts) {
    return opts.filter(function (o, i) {
      var seen = {}; P.variants.forEach(function (x) { seen[x.options[i]] = 1; });
      return Object.keys(seen).length > 1;
    });
  }
  function soonerRow(s) {
    var other = s.group !== 'variant';
    var a = document.createElement('a');
    a.className = 'agbis-sooner-row';
    a.setAttribute('href', s.path);
    a.setAttribute('data-agbis-sooner-kind', other ? 'other' : 'same');
    a.innerHTML = '<img alt="" width="56" height="56" loading="lazy">' +
      '<span class="agbis-sooner-text"><span class="agbis-sooner-name"></span>' +
      '<span class="agbis-sooner-opts"></span><span class="agbis-sooner-price"></span></span>' +
      '<span class="agbis-sooner-go" aria-hidden="true"></span>';
    q('img', a).src = img(s.image, 160);
    /* under THIS DESK the name would only repeat the page's: the row leads with its configuration;
       another desk leads with its name, its configuration under it */
    var own = P.variants.filter(function (y) { return y.id === s.id; })[0];
    q('.agbis-sooner-name', a).textContent = other ? s.title : varying(own.options).join(' · ');
    q('.agbis-sooner-opts', a).textContent = other ? [s.return, s.size].filter(Boolean).join(' · ') : '';
    q('.agbis-sooner-price', a).textContent = s.price_label;
    q('.agbis-sooner-go', a).textContent = other ? 'View' : 'Show me';
    if (!other) a.addEventListener('click', function (ev) {
      ev.preventDefault();
      showMe(P.variants.filter(function (y) { return y.id === s.id; })[0]);
    });
    return a;
  }
  function fillSooner(v) {
    var list = SOONER[v.id] || [], box = q('[data-agbis-sooner]', dialog);
    box.hidden = !list.length;
    var groups = { variant: q('[data-agbis-sooner-this]', dialog), other: q('[data-agbis-sooner-other]', dialog) };
    Object.keys(groups).forEach(function (k) { qa('.agbis-sooner-row', groups[k]).forEach(function (n) { n.remove(); }); });
    list.forEach(function (s) { groups[s.group === 'variant' ? 'variant' : 'other'].appendChild(soonerRow(s)); });
    groups.variant.hidden = !qa('.agbis-sooner-row', groups.variant).length;
    groups.other.hidden = !qa('.agbis-sooner-row', groups.other).length;
  }
  function fillItem() {
    var v = window.AGBIS_VARIANT; if (!v) return;
    /* a phone shows the photo as a 112 px thumbnail beside the title: a 360 px file, not 1200 */
    var hero = q('[data-agbis-hero]', dialog), want = img(srcOf(v.featured_image) || srcOf(P.featured_image), phone() ? 360 : 1200);
    if (hero.getAttribute('src') !== want) {
      hero.setAttribute('src', want);
      /* R5c: decoded now, not at the landing (19 ms for the 1200 px file on a slowed CPU) */
      if (hero.decode) hero.decode().catch(function () { /* a later src replaced it */ });
    }
    /* R5c: the same configuration's window is already built: no restyle at the press */
    if (dialog.getAttribute('data-agbis-filled') === String(v.id)) return;
    dialog.setAttribute('data-agbis-filled', String(v.id));
    q('[data-agbis-title]', dialog).textContent = P.title;
    /* full identification: every option, the one-value finish included */
    var spec = q('[data-agbis-spec]', dialog);
    spec.textContent = '';
    OPT.forEach(function (name, i) {
      var dt = document.createElement('dt'), dd = document.createElement('dd');
      dt.textContent = LABEL[name] || name; dd.textContent = v.options[i];
      spec.appendChild(dt); spec.appendChild(dd);
    });
    q('[data-agbis-eta]', dialog).textContent = eta();
    fillSooner(v);
  }
  function focusables() {
    return qa('button, input, a[href]', dialog).filter(function (n) {
      return !n.closest('[inert]') && !n.closest('.agbis-hp') && !n.disabled && n.getClientRects().length;
    });
  }
  function trapFocus(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || !dialog.contains(document.activeElement))) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  function setPanel(active) {
    [form, done].forEach(function (p) {
      var on = p === active;
      p.classList.toggle('is-active', on);
      p.inert = !on;
      if (on) p.removeAttribute('aria-hidden'); else p.setAttribute('aria-hidden', 'true');
    });
    dialog.setAttribute('aria-labelledby', active === form ? 'agbis-title' : 'agbis-done-title');
  }
  function settle() {
    clearTimeout(settleTimer);
    stage.classList.remove('is-swapping');
    form.classList.remove('is-leaving');
    done.classList.remove('is-entering');
  }
  /* ---------- the motion (round 4, made compositor-only in R5 / R5c; agbis-r5.js) ----------
     Every animation is tracked, so a close during an opening, or a camera, can find it. */
  var STANDARD = 'cubic-bezier(.2, 0, 0, 1)';   /* the morph: across the screen, eased both ends */
  var OUT = 'cubic-bezier(.16, 1, .3, 1)';       /* arrivals: fast, then a long settle */
  var IN = 'cubic-bezier(.4, 0, 1, 1)';          /* departures */
  var running = [];
  function track(a) { running.push(a); return a; }
  function stopAll() {
    running.forEach(function (a) { try { a.cancel(); } catch (e) { /* already gone */ } });
    running = [];
    qa('.agbis-ghost, .agbis-ghost-label', overlay).forEach(function (g) { g.remove(); });
    dialog.style.opacity = '';
  }
  function winStyle() { return '1'; }   /* window 1, A's pick (R4); the prototype's 2 and 3 are not ported */
  function still() { return !!(reduce && reduce.matches); }
  function phone() { return window.matchMedia('(max-width: 479px)').matches; }
  function box(el) { var r = el.getBoundingClientRect(); return { l: r.left, t: r.top, w: r.width, h: r.height }; }
  function inView(el) { var r = el.getBoundingClientRect(); return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight; }
  function fadeForm(delay) {
    track(form.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 220, delay: delay, easing: 'linear', fill: 'backwards' }));
  }
  function settlePhoto(delay) {
    var p = q('.agbis-media img', dialog); if (!p || !p.getClientRects().length) return;
    track(p.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 260, delay: delay, easing: 'linear', fill: 'backwards' }));
  }
  function ghost(at, ink, inkOn) {
    var g = document.createElement('div');
    g.className = 'agbis-ghost';
    g.innerHTML = '<div class="agbis-ghost-y"><div class="agbis-ghost-ink"></div></div>';
    g.style.left = at.l + 'px'; g.style.top = at.t + 'px'; g.style.width = at.w + 'px'; g.style.height = at.h + 'px';
    var i = q('.agbis-ghost-ink', g); i.style.backgroundColor = ink; i.style.opacity = String(inkOn);
    ghosts.appendChild(g);
    return g;
  }
  function plateLabel(trigger, at) {
    var l = document.createElement('div');
    l.className = 'agbis-ghost-label';
    var m = q('.agbis-plate-main', trigger); if (m) l.appendChild(m.cloneNode(true));
    l.style.left = at.l + 'px'; l.style.top = at.t + 'px'; l.style.width = at.w + 'px'; l.style.height = at.h + 'px';
    ghosts.appendChild(l);
    return l;
  }
  function onX(a, b) { return 'translateX(' + (a.l - b.l) + 'px) scaleX(' + (a.w / b.w) + ')'; }
  function onY(a, b) { return 'translateY(' + (a.t - b.t) + 'px) scaleY(' + (a.h / b.h) + ')'; }
  function morphIn(trigger, at) {
    /* R6b: the warm press read these before its first write (open); a cold one reads them here */
    at = at || measure(trigger);
    var from = at.from, to = at.to;
    var g = ghost(to, at.ink, 1), label = plateLabel(trigger, from);
    trigger.classList.add('agbis-lifted');
    var D = 420;
    /* R5c (A: "choppy at times, on desktop"; tools/perf_r5.py): EVERY motion is created in the press frame
       and nothing on the page is written again until it ends. On the live theme any style write or added
       element restyles all ~4,100 elements (12-16 ms at CPU x4, the probe in README section R5c), so the
       old landing (clear the window's opacity, start its fade) cost a frame mid-motion. */
    track(label.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 110, easing: 'linear', fill: 'both' }));
    track(g.animate([{ transform: onX(from, to) }, { transform: 'none' }], { duration: D, easing: STANDARD, fill: 'both' }));
    var tall = track(g.firstChild.animate([{ transform: onY(from, to) }, { transform: 'none' }], { duration: D, delay: 50, easing: STANDARD, fill: 'both' }));
    track(q('.agbis-ghost-ink', g).animate([{ opacity: 1 }, { opacity: 0 }], { duration: 240, delay: 150, easing: 'linear', fill: 'both' }));
    /* the window: opacity, never visibility (a hidden window drops the focus); held at 0.1% by its own
       fade's backwards fill, so it is drawn and rastered while the shape travels, then it fades in over
       the white shape (same white: only the contents appear) the moment the shape lands */
    track(dialog.animate([{ opacity: 0.001 }, { opacity: 1 }], { duration: 220, delay: D + 50, easing: 'linear', fill: 'backwards' }))
      .finished.then(function () {
        /* the motion is over: the shape leaves unseen beneath the window, the field takes the focus; one
           beat later, so the restyle never lands on the fade's last frame */
        setTimeout(function () {
          if (closing || overlay.hidden) return;   /* a close already cleared the shape (stopAll) */
          g.remove(); label.remove();
          if (document.activeElement === dialog) input.focus({ preventScroll: true });
        }, 60);
      }, function () { /* cancelled by a close */ });
    return tall;
  }
  function morphOut(trigger) {
    var from = box(dialog), to = box(trigger);
    var g = ghost(from, getComputedStyle(trigger).backgroundColor, 0), label = plateLabel(trigger, to);
    dialog.style.opacity = '0';
    var D = 340;
    track(label.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 110, delay: D - 60, easing: 'linear', fill: 'both' }));
    track(g.firstChild.animate([{ transform: 'none' }, { transform: onY(to, from) }], { duration: D, easing: STANDARD, fill: 'both' }));
    track(q('.agbis-ghost-ink', g).animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, delay: 40, easing: 'linear', fill: 'both' }));
    return track(g.animate([{ transform: 'none' }, { transform: onX(to, from) }], { duration: D, delay: 50, easing: STANDARD, fill: 'both' }));
  }
  function enter(trigger, at) {
    track(scrim.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 300, easing: 'linear', fill: 'backwards' }));
    if (trigger && (at ? at.seen : inView(trigger))) return morphIn(trigger, at);
    /* opened with its button out of view: a sheet on a phone, a rise on a desktop */
    var sheet = phone();
    track(dialog.animate(sheet ? [{ transform: 'translateY(100%)' }, { transform: 'none' }]
                               : [{ opacity: 0, transform: 'translateY(28px) scale(.97)' }, { opacity: 1, transform: 'none' }],
                         { duration: sheet ? 460 : 440, easing: OUT, fill: 'backwards' }));
    settlePhoto(sheet ? 120 : 0);
    fadeForm(120);
  }
  function leave(done) {
    var last;
    track(scrim.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 260, delay: 80, easing: 'linear', fill: 'forwards' }));
    if (lastTrigger && lastTrigger.classList.contains('agbis-lifted') && inView(lastTrigger)) last = morphOut(lastTrigger);
    else if (phone()) last = track(dialog.animate([{ transform: 'none' }, { transform: 'translateY(100%)' }], { duration: 300, easing: IN, fill: 'forwards' }));
    else last = track(dialog.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(16px) scale(.98)' }], { duration: 200, easing: IN, fill: 'forwards' }));
    last.finished.then(done, function () { /* cancelled */ });
  }

  /* ---------- R6b: warm on intent ----------
     The press used to show the window, lay it out, raster it and decode nothing new inside its own
     frame. Now the first sign of intent on the plate (pointerover, pointerdown, touchstart, focus)
     shows it at 0.1 % (.agbis-warm), unseen, out of the accessibility tree (aria-hidden) and out of
     the tab order (inert), with its contents filled; the press finds it laid out and rastered. A warm
     that never opens cools after 3 s, each intent restarting the clock; it never runs while the
     window is open or on its way out. */
  function measure(trigger) {
    return { seen: inView(trigger), from: box(trigger), to: box(dialog), ink: getComputedStyle(trigger).backgroundColor,
             gutter: scrollbar() };
  }
  function scrollbar() { return window.innerWidth - html.clientWidth; }
  /* R6b: the window lives beside <body>, never in it. The theme's body:has(...) rules (Chatra's
     [style*=...] among them) make every node added and every inline style written anywhere inside
     <body> restyle ~570 of its elements (31 ms traced at CPU x1): the press added two nodes, the
     landing removed them, the close wrote a style. Beside <body> each costs one element. The window
     keeps <body>'s look: each inherited property <body> sets is copied onto it once, at the first
     warm or open (the theme's stylesheets, some deferred, have loaded by then). */
  var INHERIT = ['color', 'font-family', 'font-size', 'font-style', 'font-weight', 'font-variant', 'font-kerning',
    'font-feature-settings', 'font-variation-settings', 'line-height', 'letter-spacing', 'word-spacing', 'text-transform',
    'text-align', 'text-indent', 'text-rendering', '-webkit-font-smoothing', '-moz-osx-font-smoothing', 'text-shadow',
    'white-space', 'word-break', 'overflow-wrap', 'hyphens', 'direction', '-webkit-text-size-adjust'];
  var inherited = false;
  function inheritBody() {
    if (inherited) return;
    inherited = true;
    var b = getComputedStyle(document.body), h = getComputedStyle(html);
    INHERIT.forEach(function (p) { var v = b.getPropertyValue(p); if (v !== h.getPropertyValue(p)) overlay.style.setProperty(p, v); });
  }
  function prime() {   /* the window's resting state: the form, no banner, no error, the submit ready */
    inheritBody();
    settle();
    fillItem();
    setPanel(form);
    banner.hidden = true; banner.classList.remove('is-info'); err.textContent = ''; input.removeAttribute('aria-invalid');
    submit.disabled = false; submit.textContent = 'Notify me';
  }
  function warm(e) {
    var t = e && e.target;
    if (!t || !t.closest || !t.closest('[data-agbis-open]')) return;
    if (closing || (!overlay.hidden && !warmed)) return;   /* open, or on its way out */
    clearTimeout(coolTimer);
    coolTimer = setTimeout(cool, 3000);
    if (warmed) return;
    warmed = true;
    prime();
    overlay.classList.add('agbis-warm');
    overlay.setAttribute('aria-hidden', 'true');
    dialog.inert = true;
    overlay.hidden = false;
  }
  function unwarm() {
    warmed = false;
    overlay.classList.remove('agbis-warm');
    overlay.removeAttribute('aria-hidden');
    dialog.inert = false;
  }
  function cool() {
    clearTimeout(coolTimer);
    if (!warmed) return;
    overlay.hidden = true;
    unwarm();
  }
  /* R5's lock: the page keeps its width by the scrollbar's own width as padding. A warm press read
     the scrollbar before its first write (at). The window spans 100vw, so the lock does not move it.
     Never scrollbar-gutter: on the root it narrows every vw unit by the scrollbar (Chromium 145),
     and the theme sizes its menu in vw under transition: all. */
  function lock(at) {
    var g = at ? at.gutter : scrollbar();
    html.style.overflow = 'hidden';
    if (g > 0) html.style.paddingRight = g + 'px';   /* no sideways jump when the scrollbar goes */
  }
  function unlock() {
    html.style.overflow = '';
    html.style.paddingRight = '';
  }
  function open(trigger) {
    if (closing || (!overlay.hidden && !warmed)) return;
    /* R6b: warm, every read comes before the first write (nothing is laid out inside the press);
       cold, the window is shown first and read after, as R5 did */
    var at = warmed && trigger ? measure(trigger) : null;
    clearTimeout(coolTimer);
    lastTrigger = trigger || null;
    closing = false;
    stopAll();
    if (warmed) unwarm(); else prime();
    lock(at);
    overlay.hidden = false;
    window.addEventListener('keydown', trapFocus, true);
    if (still()) { dialog.focus({ preventScroll: true }); input.focus({ preventScroll: true }); return; }
    enter(trigger, at);
    /* focus enters the window at once, after the motion is made (one style pass for both); the field
       takes it when the motion is done (a phone keyboard opening mid-motion would move the sheet) */
    dialog.focus({ preventScroll: true });
    /* W1 focuses the field at its own landing (morphIn); this is the fallback */
    setTimeout(function () { if (!overlay.hidden && !closing && dialog.contains(document.activeElement) && document.activeElement === dialog) input.focus({ preventScroll: true }); }, 900);
  }
  function close() {
    if (overlay.hidden || warmed || closing) return;
    closing = true;
    stopAll();
    settle();
    window.removeEventListener('keydown', trapFocus, true);
    if (still()) return teardown();
    leave(teardown);
  }
  function teardown() {
    stopAll();
    overlay.hidden = true;
    closing = false;
    window.removeEventListener('keydown', trapFocus, true);
    unlock();
    if (lastTrigger) lastTrigger.classList.remove('agbis-lifted');
    var back = lastTrigger && lastTrigger.getClientRects().length ? lastTrigger : q('#add-to-cart-btn');
    if (back) back.focus({ preventScroll: true });
  }
  /* R6c: the door's own rule, by text (restock.py EMAIL_RE and its 254 cap; qa_port PORT-18) */
  var EMAIL_RE = /^[^@\s<>\"',;]+@[^@\s<>\"',;]+\.[^@\s<>\"',;]{2,}$/;
  function valid(s) { return s.length <= 254 && EMAIL_RE.test(s); }
  function showDone(email, already) {
    q('[data-agbis-done-text]', dialog).textContent = already ? 'You’re already on the list' : 'You’re on the list';
    var copy = q('[data-agbis-done-copy]', dialog);
    copy.innerHTML = already ? 'We already have <strong></strong> down for this one. We’ll email you once it’s back.'
      : 'We’ve sent a confirmation to <strong></strong>. We’ll email you once it’s back.';
    q('strong', copy).textContent = email;
    /* one height: both panels share one grid cell, so the window cannot grow or shrink here */
    if (!(reduce && reduce.matches)) {
      stage.classList.add('is-swapping');
      form.classList.add('is-leaving');
      done.classList.add('is-entering');
      settleTimer = setTimeout(settle, 1400);   /* the backstop if animationend never arrives */
    }
    setPanel(done);
    q('#agbis-done-title', dialog).focus({ preventScroll: true });
  }
  /* the theme selects (its selectVariantById sets every control, fires their change events and runs its
     own update at once); a page without it gets the controls set and their change events here */
  function select(v) {
    var vs = window.variantSelector;
    if (vs && typeof vs.selectVariantById === 'function' && vs.product) vs.selectVariantById(v.id);
    else OPT.forEach(function (name, i) {
      radioFor(name).forEach(function (r) {
        if (r.value === v.options[i] && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      var s = q('select[name="' + name + '"]');
      if (s && s.value !== v.options[i]) { s.value = v.options[i]; s.dispatchEvent(new Event('change', { bubbles: true })); }
    });
    render();
  }

  /* ---------- Show me (R5c) ----------
     A: "When clicking Show me on mobile, it has to scroll up to the selection and what they selected, and
     animate that selection too, not after scrolling up to that point"; "if it's a different destination,
     just take them there" (the other desks' rows stay plain links, soonerRow). The page starts scrolling at
     the press, under the leaving window, until the first changed option sits under the sticky bar; the
     theme's own selection trace (ag-rt-trace-draw on :has(input:checked)) is HELD while the window covers
     the tiles and released while the page is still moving; a changed dropdown draws the same trace once. */
  var SHOW_DRAW = 300;      /* the theme's trace runs 0.3 s */
  function optControl(name) {
    var r = radioFor(name)[0];
    return r ? r.closest('.product-header_radio-list') : q('select[name="' + name + '"]');
  }
  function showMe(v) {
    var was = current(), calm = still(), held = [];
    var changed = OPT.filter(function (name, i) { return was[i] !== v.options[i]; });
    if (!calm) changed.forEach(function (name) {
      var list = optControl(name);
      if (!list || list.tagName === 'SELECT') return;
      var old = radioFor(name).filter(function (r) { return r.checked; })[0];
      if (old && old.closest('label')) old.closest('label').classList.add('agbis-was');
      list.classList.add('agbis-hold');
      held.push(list);
    });
    select(v);   /* selected first: the window leaves without flying back into a button that is gone */
    close();
    var rows = changed.map(function (name) { var c = optControl(name); return c && (c.closest('.product-header_option') || c); })
      .filter(Boolean), dur = 0;
    if (rows.length) {
      var nav = q('.section_navbar'), navB = nav ? Math.max(0, nav.getBoundingClientRect().bottom) : 0;
      var top = rows[0].getBoundingClientRect().top, bottom = rows[rows.length - 1].getBoundingClientRect().bottom;
      if (top < navB + 8 || bottom > window.innerHeight - 8) {
        var to = Math.max(0, window.scrollY + top - navB - 16);
        if (calm) window.scrollTo({ top: to, behavior: 'instant' });
        else dur = glide(to);
      }
    }
    if (calm) return;
    /* the trace starts while the page is still moving and finishes as it lands (never after it) */
    setTimeout(function () {
      held.forEach(function (list) { list.classList.remove('agbis-hold'); });
      changed.forEach(function (name) { var s = q('select[name="' + name + '"]'); if (s) traceSelect(s); });
      /* the old tile's trace fades on the theme's own 0.15 s, drawn all the way round */
      setTimeout(function () { qa('.agbis-was').forEach(function (l) { l.classList.remove('agbis-was'); }); }, 220);
    }, Math.max(220, dur - SHOW_DRAW));
  }
  function glide(to) {
    var from = window.scrollY, d = to - from, t0 = performance.now(), stop = false;
    var dur = Math.round(Math.min(700, Math.max(420, 300 + Math.abs(d) * 0.4)));
    if (Math.abs(d) < 1) return 0;
    function quit() { stop = true; }
    ['wheel', 'touchstart', 'keydown'].forEach(function (t) { window.addEventListener(t, quit, { once: true, passive: true }); });
    requestAnimationFrame(function step(now) {
      var k = Math.min(1, Math.max(0, (now - t0) / dur));
      if (stop) return;
      var e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
      window.scrollTo({ top: from + d * e, behavior: 'instant' });   /* instant: the page's CSS asks for smooth */
      if (k < 1) requestAnimationFrame(step);
      else ['wheel', 'touchstart', 'keydown'].forEach(function (t) { window.removeEventListener(t, quit); });
    });
    return dur;
  }
  function traceSelect(s) {
    var t = s.parentElement && q('.agbis-sel-trace', s.parentElement);
    if (!t) return;
    clearTimeout(t._agbisOff);
    if (t.classList.contains('is-on')) { t.classList.remove('is-on'); getComputedStyle(t).opacity; }
    t.classList.add('is-on');
    t._agbisOff = setTimeout(function () { t.classList.remove('is-on'); }, 1600);
  }
  function selTraces() {
    OPT.forEach(function (name) {
      var s = q('select[name="' + name + '"]');
      if (!s || !s.parentElement || q('.agbis-sel-trace', s.parentElement)) return;
      s.parentElement.classList.add('agbis-sel-host');
      s.insertAdjacentHTML('afterend', '<svg class="ag-rt-trace agbis-sel-trace" aria-hidden="true" focusable="false"><rect pathLength="100"></rect></svg>');
    });
  }

  /* ---------- the submit ----------
     mock (the preview): nothing leaves the page; "fail" in the address shows the server-error state.
     live: POST to the SRM restock door (SPEC 147): 200 {ok, state: subscribed | already | available},
     400 / 429 / 503 {ok: false, error: "<a sentence>"} shown as it is. */
  var FAIL = 'We couldn’t save your alert just now. Try again, or email support@arcgrove.com and we’ll add you.';
  function failed(text, info) {
    submit.disabled = false; submit.textContent = 'Notify me';
    banner.hidden = false;
    banner.classList.toggle('is-info', !!info);
    banner.textContent = text;
  }
  function post(email, v) {
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 12000) : 0;
    return fetch(D.door, {
      method: 'POST', mode: 'cors', credentials: 'omit', signal: ctl ? ctl.signal : undefined,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ email: email, variant_id: v.id, handle: P.handle,
                             page_url: location.href.split('#')[0], hp: q('.agbis-hp input', form).value })
    }).then(function (r) {
      clearTimeout(timer);
      return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j || {} }; });
    }, function (e) { clearTimeout(timer); throw e; });
  }
  function onSubmit(e) {
    e.preventDefault();
    var email = input.value.trim(), v = window.AGBIS_VARIANT;
    banner.hidden = true;
    if (q('.agbis-hp input', form).value) { showDone(email, false); return; }
    if (!valid(email)) {
      input.setAttribute('aria-invalid', 'true');
      err.textContent = 'Enter a valid email address.';
      input.focus(); return;
    }
    input.removeAttribute('aria-invalid'); err.textContent = '';
    submit.disabled = true; submit.textContent = 'Saving';
    window.AGBIS_LAST_SUBMIT = { email: email, variant_id: v.id, mode: D.mode };
    if (D.mode !== 'live') {
      setTimeout(function () {
        if (/fail/i.test(email)) return failed(FAIL);
        var key = email.toLowerCase() + '|' + v.id;
        var already = !!subscribed[key]; subscribed[key] = 1;
        showDone(email, already);
      }, 500);
      return;
    }
    post(email, v).then(function (res) {
      var b = res.body;
      if (res.status === 200 && b.ok) {
        if (b.state === 'available') return failed('Good news: this configuration is back in stock. Refresh the page to add it to your cart.', true);
        return showDone(email, b.state === 'already');
      }
      failed(b && b.error ? String(b.error) : FAIL);
    }, function () { failed(FAIL); });
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'agbis-overlay'; overlay.hidden = true;
    overlay.innerHTML =
      '<div class="agbis-scrim" data-agbis-close></div>' +
      '<div class="agbis-dialog" role="dialog" aria-modal="true" aria-labelledby="agbis-title" tabindex="-1">' +
        '<button type="button" class="agbis-close" data-agbis-close aria-label="Close">' + (ICON.x || '') + '</button>' +
        '<div class="agbis-media"><img data-agbis-hero alt="" width="1200" height="1200" decoding="async"></div>' +
        '<div class="agbis-body"><div class="agbis-stage">' +
          '<form class="agbis-panel agbis-form is-active" novalidate>' +
            '<p class="agbis-eyebrow">' + (ICON.bell || '') + '<span>Notify me</span></p>' +
            '<h2 class="agbis-title" id="agbis-title">We’ll email you when it’s back</h2>' +
            '<p class="agbis-name" data-agbis-title></p>' +
            '<dl class="agbis-spec" data-agbis-spec></dl>' +
            '<p class="agbis-when">' + (ICON.cal || '') + '<span data-agbis-eta></span></p>' +
            '<p class="agbis-banner" role="alert" hidden></p>' +
            '<div class="agbis-field">' +
              '<label class="agbis-sr" for="agbis-email">Email address</label>' +
              '<input class="agbis-input" id="agbis-email" name="email" type="email" inputmode="email" autocomplete="email" placeholder="Email address" aria-describedby="agbis-err">' +
              '<p class="agbis-field-error" id="agbis-err" aria-live="polite"></p>' +
            '</div>' +
            '<span class="agbis-hp" aria-hidden="true" inert><input type="text" name="agbis_x" tabindex="-1" autocomplete="off"></span>' +
            '<button type="submit" class="agbis-submit">Notify me</button>' +
            '<p class="agbis-fine">We do not sell your information.</p>' +
          '</form>' +
          '<div class="agbis-panel agbis-done" aria-hidden="true" inert>' +
            '<div class="agbis-done-head">' +
              '<span class="agbis-check" aria-hidden="true">' + (ICON.check || '') + '</span>' +
              '<h2 class="agbis-done-title" id="agbis-done-title" tabindex="-1" data-agbis-done-text></h2>' +
            '</div>' +
            '<p class="agbis-done-copy" data-agbis-done-copy></p>' +
            '<div class="agbis-sooner" data-agbis-sooner hidden>' +
              '<p class="agbis-sooner-label">Need it sooner? These are in stock and ship now.</p>' +
              '<div class="agbis-sooner-group" data-agbis-sooner-this><p class="agbis-sooner-kind">This desk</p></div>' +
              '<div class="agbis-sooner-group" data-agbis-sooner-other><p class="agbis-sooner-kind">Other Quick Ship desks</p></div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    /* R5c: the travelling shape's own layer, never a sibling of the window (adding or removing a
       sibling restyled the whole window: 20 ms at the landing on a slowed CPU) */
    ghosts = document.createElement('div');
    ghosts.className = 'agbis-ghosts';
    overlay.appendChild(ghosts);
    html.appendChild(overlay);   /* R6b: beside <body>, never in it (inheritBody) */
    scrim = q('.agbis-scrim', overlay); dialog = q('.agbis-dialog', overlay); stage = q('.agbis-stage', overlay);
    form = q('.agbis-form', overlay); done = q('.agbis-done', overlay);
    input = q('#agbis-email', overlay); err = q('#agbis-err', overlay); banner = q('.agbis-banner', overlay); submit = q('.agbis-submit', overlay);
    form.addEventListener('submit', onSubmit);
    qa('[data-agbis-close]', overlay).forEach(function (n) { n.addEventListener('click', close); });
    done.addEventListener('animationend', function (e) { if (e.animationName === 'agbis-wipe' && e.target.matches('.agbis-done-title')) settle(); });
  }

  function shown() { return qa('[data-agbis-open]').filter(function (n) { return n.getClientRects().length; })[0]; }
  function init() {
    setAttr(html, 'data-agbis-w', '1');   /* window 1, A's pick (R4) */
    setAttr(html, 'data-agbis-v', '1');   /* button V1, A's pick (R3) */
    build();
    selTraces();
    P.variants.forEach(function (v) { if (!v.available) SOONER[v.id] = sooner(v); });
    /* the plate opens the one window; the press that opened it gets the focus back */
    window.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-agbis-open]');
      if (b) { e.preventDefault(); open(b); }
    }, true);
    /* R6b: warm on intent, on every element that opens the window (window, capture phase: the theme's
       document-level stoppers; a touch listener is passive, it never holds the scroll). pointerover,
       never pointerenter: Chromium does not deliver a pointerenter to a window capture listener */
    ['pointerover', 'pointerdown', 'focus'].forEach(function (t) { window.addEventListener(t, warm, true); });
    window.addEventListener('touchstart', warm, { capture: true, passive: true });
    /* this file's window capture listener runs before agcp.js's (the deferred scripts run in document
       order and agbis-notify renders inside the form, the chair card after it; PORT-9): out of stock,
       the chair card's quantity press sets the quantity and leaves the tick alone (R5b) */
    window.addEventListener('click', function (e) {
      if (!isOut()) return;
      var st = e.target && e.target.closest && e.target.closest('[data-agcp-qty-step]');
      var cb = st && chairCheck();
      if (!cb || cb.checked) return;
      setTimeout(function () { if (cb.checked) cb.checked = false; }, 0);
    }, true);
    window.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('.product-variant-option')) { render(); return; }
      if (t.matches('[data-agcp-card] [data-agcp-check]') && t.checked && isOut()) chairAdd(t);
    }, true);
    /* the theme's own availability write (after its product fetch, a quick-ship toggle, a later change) */
    var oos = document.getElementById('out-of-stock-container');
    if (oos && window.MutationObserver) new MutationObserver(function () { render(); }).observe(oos, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('pageshow', function (e) { if (e.persisted) render(); });
    render();
    addFromLink();
    window.AGBIS = { open: function () { open(shown()); }, close: close, render: render, eta: eta, sooner: sooner,
                     mode: D.mode, select: function (id) { var v = byId(id); if (v) select(v); },
                     anims: function () { return running.slice(); },
                     /* R6b: closed | warm | open | closing (a warm window is a closed one) */
                     state: function () { return closing ? 'closing' : overlay.hidden ? 'closed' : warmed ? 'warm' : 'open'; } };
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
